import { useTranslation } from "next-i18next"

import {
  Dropdown,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownTrigger,
} from "@/core/components/Dropdown"
import { Icon } from "@/core/components/icon/Icon"
import { cn } from "@/utils/helpers"

const LanguageSwitcher = () => {
  const { i18n } = useTranslation()
  const languages = ["en", "da", "nb"]

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang)
    localStorage.setItem("language", lang)
  }

  const flags = {
    en: "gb",
    da: "dk",
    nb: "no",
  }

  const languageNames = {
    en: "English",
    da: "Dansk",
    nb: "Norsk",
  }

  return (
    <Dropdown>
      <DropdownTrigger className="hover:bg-outline-variant/90 active:bg-outline-variant focus:bg-outline-variant text-md-medium flex w-fit cursor-pointer items-center justify-center gap-2 rounded-lg p-1 py-2 pl-3 leading-none outline-none">
        <Icon icon="language" className="text-on-surface-variant" />
        <span className="text-md-medium flex items-center justify-center">
          {languageNames[i18n.language] || "🌐"}
        </span>
        <Icon icon={"arrow_drop_down"} size="1.5rem" />
      </DropdownTrigger>
      <DropdownMenuContent
        className="bg-container-base"
        side="bottom"
        align="end"
      >
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            className={cn("h-14 min-w-[18.5rem] px-3 py-4 text-2xl")}
            onClick={() => handleLanguageChange(lang)}
          >
            <img
              src={`https://hatscripts.github.io/circle-flags/flags/${flags[lang]}.svg`}
              width="24"
            />
            <span className="text-md ml-1">
              {languageNames[lang] || "Unknown"}
            </span>
            {i18n.language === lang && (
              <Icon icon="check" className="text-on-surface-variant ml-auto" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </Dropdown>
  )
}

export default LanguageSwitcher
